import React from 'react';
import './Loader.css';

/**
 * Loader Component
 *
 * @param {string} size - 'sm' | 'md' | 'lg'
 * @param {string} variant - 'spinner' | 'dots' | 'pulse'
 * @param {string} color - 'primary' | 'white' | 'gray'
 * @param {boolean} fullPage - Center in viewport
 * @param {string} text - Loading text
 */
const Loader = ({
  size = 'md',
  variant = 'spinner',
  color = 'primary',
  fullPage = false,
  text,
  className = '',
}) => {
  const loaderClassNames = [
    'oz-loader',
    `oz-loader--${size}`,
    `oz-loader--${color}`,
    fullPage && 'oz-loader--full-page',
    className
  ].filter(Boolean).join(' ');

  const renderLoader = () => {
    switch (variant) {
      case 'dots':
        return (
          <div className="oz-loader__dots">
            <span className="oz-loader__dot" />
            <span className="oz-loader__dot" />
            <span className="oz-loader__dot" />
          </div>
        );
      case 'pulse':
        return <div className="oz-loader__pulse" />;
      case 'spinner':
      default:
        return (
          <svg className="oz-loader__spinner" viewBox="0 0 50 50">
            <circle
              className="oz-loader__spinner-path"
              cx="25"
              cy="25"
              r="20"
              fill="none"
              strokeWidth="4"
            />
          </svg>
        );
    }
  };

  return (
    <div className={loaderClassNames}>
      {renderLoader()}
      {text && <span className="oz-loader__text">{text}</span>}
    </div>
  );
};

// Page Loader - Full page loading overlay
export const PageLoader = ({ text = 'Loading...' }) => (
  <Loader
    size="lg"
    variant="spinner"
    fullPage
    text={text}
  />
);

// Inline Loader - For inline loading states
export const InlineLoader = ({ text }) => (
  <Loader
    size="sm"
    variant="dots"
    text={text}
  />
);

export default Loader;
